export default __webpack_public_path__ + "static/media/bench-window-seat-trapezoid-front.e24c7916.webp";